import * as React from "react";
const SvgLike20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16.6 5.046a3.36 3.36 0 0 0-4.697.318L10 7.505l-1.903-2.14a3.36 3.36 0 1 0-4.77 4.717L10 16.149l6.674-6.067a3.36 3.36 0 0 0-.074-5.036Zm-6.192-1.01a5.36 5.36 0 1 1 7.61 7.526L10 18.852l-8.019-7.29a5.36 5.36 0 1 1 7.61-7.526l.41.459.407-.46Z",
      clipRule: "evenodd"
    })
  );
export default SvgLike20Px;
